import React from "react";
import UpcomingWrap from "./UpcomingWrap";

function Upcoming(props) {
    return (
        <>
            <UpcomingWrap/>
        </>
    )
}

export default Upcoming;
